<template>
  <div class="header flex-between " :class="{'header-fixed':isFixed}">
     <div class="header-item" style="display: flex;">
        <img class="arrow-icon" @click="back"  src="@/assets/stuCommon/arrow-left.png" alt="">
        <div @click="back" v-if="!isClass" class="class-title flex-center" style="margin-right: 10px;">返回</div>
        <div v-if="isClass" class="flex-center">
          <div class="class-title">{{ classInfo.courseName || '随堂测试'}}</div>
          <div class="line">|</div>
          <div class="item-title"><room-timer :time="duration"></room-timer></div>
          <div class="line">|</div>
          <div class="item-title">{{ versions }}</div>
          <div class="iconTip" @click="showNotice">
        <i class="el-icon-warning-outline " ></i>
        注意事项</div>
        </div>
        
     </div>
     <div class="header-item title">{{ title }}</div>
     <div class="header-item" style="display: flex; justify-content: flex-end;">
      <slot name="right-buttons"></slot>
     </div>
  </div>
</template>

<script>
  import {mapState} from "vuex";
  import RoomTimer from "@/views/attendClass/roomController/roomTimer.vue";
  const dayjs = require('dayjs')
  import { Dialog } from 'vant';
   
  export default {
    components: {RoomTimer},
    props: {
      title: {
        type: String,
        default: ''
      },
      isFixed: {
        type: Boolean,
        default: false
      },
      isClass: {
        type: Boolean,
        default: false
      },
      isBack:{
        type: Boolean,
        default: true,
      },
      isTest:{
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        duration: 0,
        timer: null,
        versions:process.env.VUE_APP_VERSIONS,
      }
    },
    watch:{
      '$store.state.isStartClass': {
          async handler(newValue, oldValue) {
            if(newValue == 1){
              if(!this.$store.state.classInfo.actualBeginTime){
                  this.timer = setInterval(() => {
                  this.duration++
                }, 1000)
              }else{
                let beginTime = dayjs(this.$store.state.classInfo.actualBeginTime).unix()
                let nowTime = dayjs().unix()
                this.duration = nowTime - beginTime
                this.timer = setInterval(() => {
                  this.duration++
                }, 1000)
              }
            }
          }
      },
    },
        
    computed:{
      ...mapState([
        'classInfo' // 映射 this.items 为 this.$store.state.items
      ])
    },
    methods: {
      showNotice(){
        this.$emit('showNotice')
      },
      back() {
        if(this.isBack){
          if(this.isClass){
            Dialog.confirm({
              title: '',
              message: '您确定要退出本次训练室吗？',
            })
            .then(() => {
              this.$router.go(-1)
            })
            .catch(() => {
            });
          }else if(this.isTest){
            Dialog.confirm({
              title: '',
              message: '您要终止检测返回首页吗？',
            })
            .then(() => {
              this.$router.go(-1)
            })
            .catch(() => {
            });
          }else{
            this.$router.go(-1)
          }
        }else{
          this.$emit('switchComponent')
        }
      }
    },
    beforeDestroy() {
      if(this.timer){
        clearInterval(this.timer); // 清除定时器
      }
    }
  }
</script>

<style lang="scss" scoped>
.header{
  height: 88px;
}
.header-fixed{
  width: 100%;
  position: fixed;
  top: 50px;
  left: 0;
  padding: 0 32px;
  z-index: 1;
}
.header-item{

}
.title{
  color: #1D2129;
  text-align: center;
  font-size: 32px;
  font-weight: 600;
}
.arrow-icon{
  width: 48px;
  height: 48px;
  margin-left: -16px;
}
.class-title{
  color: #1D2129;
  font-size: 28px;
  font-weight: 500;
}
.item-title{
  color: #4E5969;
  font-size: 24px;
}
.line{
  font-size: 24px;
  color: #C9CDD4;
  margin: 0 16px;
}
::v-deep .clock-icon{
  width: 28px;
  height: 28px;
  margin-right: 16px;
}
::v-deep .class-id{
  color:  #4E5969;
  font-size: 24px;
}
.iconTip{
  color: #F53F3F;
  margin-left: 12px;
}
</style>